import Row from './Row';

import { colors } from '../../constants/styleConstants';

const LinkRow = Row.withComponent('a').extend`
  text-decoration: underline;

  &:hover,
  &:focus {
    color: ${colors.darkGrey};
  }
`;

export default LinkRow;



// WEBPACK FOOTER //
// ./src/components/common/LinkRow.js